<template>
    <div class="login-wrap">
        <div class="logo"><img src="@/assets/img/logo2.png"  alt="" /></div>
        <div class="ms-login">
            <el-form :model="param" ref="login" class="ms-content loginin" v-show="!isQR">
                <el-form-item prop="username" class="item">
                    <el-input v-model="param.username" placeholder="用户名" class="input"> </el-input>
                </el-form-item>
                <el-form-item prop="password" class="item">
                    <el-input
                        type="password"
                        class="input"
                        size="80px"
                        placeholder="密码"
                        v-model="param.password"
                        @keyup.enter.native="submitForm()"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <JcRange :successFun="successIt" :errorFun="failIt" :key="tempNum"></JcRange>
                </el-form-item>
                <div class="login-btn">
                    <el-button type="primary" @click="submitForm()">登录</el-button>
                </div>
            </el-form>

            <div class="img_wrap" v-show="isQR">
                <img :src="QR" alt="" />
                <span class="iconfont icon-qiehuan icons" @click="closeIsQR"></span>
            </div>
            <div class="mask" v-show="loading">
                <i class="el-icon-loading icons"></i>
            </div>
        </div>
    </div>
</template>

<script>
import { apiLogin, apiLogin_QR, apiLogin_scanQR, repeatLogin } from '@/request/api'; // 导入我们的api接口
import JcRange from '@/components/common/slider.vue';
export default {
    data: function () {
        return {
            param: {
                username: '',
                password: ''
            },
            rules: {
                username: [
                    {
                        required: true,
                        message: '请输入用户名',
                        trigger: 'blur'
                    }
                ],
                password: [
                    {
                        required: true,
                        message: '请输入密码',
                        trigger: 'blur'
                    }
                ]
            },
            status: false,
            tempNum: '1',

            isQR: false,
            QR: '',
            timeObj: {},
            ticket: '',
            loading: false,
            timeID: '',

            dialogFormVisible: false,
            formLabelWidth: '120px',
            form: {
                lv_login_staff: null,
                lv_password: null,
                login_staff: null
            }
        };
    },
    components: {
        JcRange
    },
    beforeCreate() {
        sessionStorage.removeItem('userToken');
        localStorage.removeItem('local_token');
    },
    created() {},
    mounted() {
        this.$fingerprint.then((fp) => {
            fp.get().then((result) => {
                this.param.visitorid = result.visitorId; // 这里获取设备的指纹ID
            });
        });
        //  this.setBodyBackGround()
    },
    methods: {
        successIt: function () {
            this.status = true;
        },
        failIt: function () {
            this.status = false;
        },

        submitForm() {
            let that = this;
            this.$refs.login.validate((valid) => {
                if (valid) {
                    if (this.status == true) {
                        // 判断是否滑块验证
                        apiLogin({
                            login_staff: this.param.username,
                            password: this.param.password,
                            visitorid: this.param.visitorid
                            // debug:1,
                            // cookie:cookie
                        }).then((res) => {
                            if (res.code == 2000) {
                                localStorage.setItem('ms_username', this.param.username);
                                sessionStorage.setItem('userToken', res.data.token);

                                if (!localStorage.getItem('local_token')) localStorage.setItem('local_token', res.data.local_token);
                                this.$message.success(res.msg);
                                if (
                                    /Android|webOS| iPhone | iPad | iPod |BlackBerry|opera mini|opera mobile|appleWebkit.*mobile|mobile/i.test(
                                        navigator.userAgent
                                    )
                                ) {
                                    this.$message.error('移动端系统正在维护中…');
                                } else {
                                    localStorage.setItem('type', '首页');
                                    this.$router.push('/indexpage');
                                }
                            } else {
                                this.tempNum = Math.random();
                                this.$message.error(res.data.info);
                                this.status = false;
                            }
                        });
                    } else {
                        this.$message.error('请验证');
                    }
                } else {
                    this.$message.error('请输入账号和密码');
                    return false;
                }
            });
        },
        closeIsQR() {
            // 关闭
            this.isQR = false;
            if (this.timeID) clearTimeout(this.timeID);
        },
        // 二维码
        QRcode() {
            this.loading = true;
            apiLogin_QR({
                type: this.$bus.data.type
            }).then((res) => {
                this.QR = res.img;
                this.isQR = true;
                this.loading = false;
                sessionStorage.setItem('ticket', res.ticket);
                this.ticket = res.ticket;
                this.timer();
            });
        },
        // 获取扫码状态
        timer() {
            if (this.timeID) clearTimeout(this.timeID);
            this.timeID = setTimeout(() => {
                apiLogin_scanQR({
                    ticket: this.ticket,
                    type: this.$bus.data.type
                }).then((res) => {
                    let { type, token, content } = res.data;
                    if (res.code == 2000) {
                        if (type == 1) {
                            if (!localStorage.getItem('local_token')) localStorage.setItem('local_token', res.data.local_token);
                            sessionStorage.setItem('userToken', token);
                            this.$router.push('/');
                            this.$message.success('登录成功');
                        } else if (type == 3 || type == 4) {
                            this.$message.error(content);
                        } else if (type == 2) {
                            this.QRcode();
                        } else if (type == 0) {
                            this.timer();
                        }
                    }
                });
            }, 2600);
        }
    }
};
</script>

<style scoped lang="scss">
.el-dialog__wrapper {
    left: 30%;
}
.login-wrap {
    position: relative;
    background-color: #e0e0e0;
    background: url(../../assets/img/login_bg.png) no-repeat;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 100%;

    .logo {
        position: absolute;
        left: 100px;
        top: 60px;
        width: 220px;
        img {
            width: 100%;
            height: auto;
        }
    }

    .ms-login {
        width: 438px;
        height: 340px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background: rgba(255, 255, 255, 1);
        padding: 0 60px;
        box-sizing: border-box;
        box-shadow: 0px 10px 16px 0px rgba(19, 37, 127, 0.08), 0px 4px 10px 0px rgba(19, 37, 128, 0.0784);

        .loginin {
            padding-top: 50px;

            .item {
                margin-bottom: 30px;
            }
            .input {
                background-color: #fff;
            }
            .el-input__icon {
                font-size: 24px;
                line-height: 40px;
                margin-right: 10px;
            }
            /deep/.el-input__inner {
                height: 34px;
                font-size: 14px;
                background-color: #fff !important;
                border: 1px solid #eff0f6;
                padding-left: 10px;
                border-radius: 0px;
            }
            /deep/.el-form-item__label {
                font-weight: 600;
                font-size: 12px;
                color: rgba(23, 15, 73, 1);
                margin-bottom: 15px;
            }

            .login-btn {
                text-align: center;
                margin: 20px 0;

                > button {
                    width: 100%;
                    height: 33px;
                    background-color: #0084ff;
                    font-size: 16px;
                    border-radius: 0;
                }
            }
        }

        .img_wrap {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: 30px;

            > img {
            }

            .icons {
                cursor: pointer;
                font-size: 20px;
                line-height: 32px;
                margin-bottom: 10px;
                padding-right: 30px;
                align-self: flex-end;
            }
        }

        .mask {
            position: absolute;
            z-index: 10;
            background-color: rgba($color: #000000, $alpha: 0.3);
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            display: flex;
            justify-content: center;
            align-items: center;

            .icons {
                font-size: 25px;
                color: #fff;
            }
        }
    }
}
</style>
